// src/pages/B2B/event-reports/pdf/warm/sections/WarmCta.tsx
import React from 'react';

export function WarmCta(): React.ReactElement {
  return (
    <section className="cta">
      <div className="cta-card">
        <h3>Want your venue&apos;s free bar-crawl stats?</h3>
        <p>Get a custom report like this one for your bar — on the house.</p>
        <a className="cta-btn" href="mailto:socialsparkappllc@gmail.com">socialsparkappllc@gmail.com</a>
      </div>
    </section>
  );
}
